import { useTranslation } from 'react-i18next';
export default function IssuesTopicItem({ issue, isSelected, handleClick }) {
	const { t } = useTranslation();
	return (
		<div className={`issue-topic-container ${isSelected ? 'selected-issue-topic' : ''}`} onClick={(e) => handleClick(issue)}>
			<div className='issue-topic-title'>{issue.name}</div>
			<div className='issue-topic-subtitle'>
				{issue.experience_percentage}
				{t('experienceIt')}
			</div>
		</div>
	);
}
